import { useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { useNavigate } from 'react-router-dom';
import Bg1 from 'assets/mypage/Sub/sub.avif'
import CustomInput from 'components/common/CustomInput';
import CustomButton from 'components/common/CustomButton';
import { correctEmail, correctPw } from 'components/common/regex';
import { toast } from 'react-toastify';
import { ReactComponent as EyeOn } from 'assets/common/eyeOn.svg'
import { ReactComponent as EyeOff } from 'assets/common/eyeOff.svg'
import { jsonAxios } from 'components/axios';
import CustomSelect from 'components/common/CustomSelect';
import { activeSelect } from 'data/quote';
import { useGetUser } from 'atom/user';
import { encryptAES } from 'components/encryptDecrpt';
import axios from 'axios';
import AuthButton from 'components/common/AuthButton';
import Timer from 'components/common/Timer';

const SubAccountCreate = () => {
    const user = useGetUser();
    const navigate = useNavigate();
    const [signUpInfo, setSignUpInfo] = useState({
        email: '',
        password: '',
        isActive: true,
        emailChk: false
    })

    const [emailChk, setEmailChk] = useState<boolean>(false);
    const [clear, setClear] = useState<boolean>(false)
    const [isShow, setIsShow] = useState<boolean>(false)
    const [pwChk, setPwChk] = useState<boolean>(false);
    const [timeKey, setTimeKey] = useState<number>(0);
    const [isTimeOut, setIsTimeOut] = useState<boolean>(false)
    const [authCode, setAuthCode] = useState<string>('');
    const [serverAuthCode, setServerAuthCode] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (user.id === undefined) return;
        if (!user.isMaster) {
            toast.error('권한이 없습니다.')
            navigate('/mypage/editProfile', { replace: true })
        }
    }, [user.id, user.isMaster]);

    useEffect(() => {
        setClear(correctPw(signUpInfo.password) && signUpInfo.emailChk)
    }, [signUpInfo])

    useEffect(() => {
        if (authCode.length > 5 && serverAuthCode) {
            toast[encryptAES(authCode) === serverAuthCode ? 'success' : 'error'](
                encryptAES(authCode) === serverAuthCode ? '정상적으로 인증되었습니다.' : '인증번호가 일치하지않습니다.'
            );
            setSignUpInfo(prev => ({ ...prev, emailChk: encryptAES(authCode) === serverAuthCode }));
        }
    }, [authCode, serverAuthCode]);

    useEffect(() => {
        setTimeKey(0)
        setIsTimeOut(false)
        setAuthCode('')
        setServerAuthCode('')
    }, [signUpInfo.email]);

    const sendEmail = (reSend?: boolean) => {
        if (!signUpInfo.email) return toast.error('이메일을 입력해주세요.')
        setLoading(true)
        const reqData = {
            email: signUpInfo.email,
            status: 'signUp',
        }
        postVerifyEmail(reqData).then(res => {
            // console.log(res.data)
            if (res.data.code === 200) {
                toast.success('인증번호를 발송했습니다.')
                setServerAuthCode(res.data.data)
                // console.log('키 >>>', decryptAES(res.data.data))
                !reSend && setTimeKey(1)
            }
            else if (res.data.code === 400) {
                toast.error('이미 가입된 이메일입니다.')
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const postVerifyEmail = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL2}verifyEmail`
        return await axios.post(url, reqData)
    }

    const reSendEmail = () => {
        setTimeKey(k => k + 1)
        setIsTimeOut(false)
        setAuthCode('')
        sendEmail(true);
    }

    const createSubAccount = () => {
        jsonAxios.post('signup/sub', signUpInfo).then(res => {
            if (res.data.code === 200) {
                toast.success('정상적으로 생성되었습니다.')
                navigate(-1)
            }
            else if (res.data.code === 400) {
                toast.error(res.data.message)
            }
        })
    }

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <div
                className="relative flex justify-center items-center bg-primary bg-cover h-60 mobile:h-30 text-white"
                style={{
                    backgroundPosition: "center",
                    backgroundImage: `url(${Bg1})`,
                }}
            >
                <div className='z-10 relative flex flex-col justify-center items-center gap-2'>
                    <p className='font-semibold text-32 tablet:text-2xl'>서브계정 생성</p>
                </div>
            </div>
            <Container className="mb-6 py-10 tablet:pt-4 h-full">
                <div className='flex flex-col justify-between bg-white mx-auto mb-10 p-10 tablet:p-4 rounded-lg max-w-[512px] min-h-[680px] tablet:min-h-0'>
                    <div className='flex flex-col gap-6'>
                        <div className='flex flex-col gap-3'>
                            <p className='font-semibold mobile:text-base text-lg'>
                                이메일<span className='text-red'> *</span>
                            </p>
                            <div className='flex gap-3'>
                                <CustomInput
                                    type={'email'}
                                    value={signUpInfo.email}
                                    error={emailChk}
                                    fontSize='base'
                                    autocompleteOff
                                    disabled={signUpInfo.emailChk}
                                    placeholder={'아이디로 사용할 이메일을 등록해주세요'}
                                    onBlur={(e) => {
                                        if (e.target.value) {
                                            setEmailChk(!correctEmail(e.target.value))
                                            if (!correctEmail(e.target.value)) {
                                                toast.error('이메일 형식이 올바르지 않습니다.')
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        setEmailChk(false)
                                        setSignUpInfo(p => ({
                                            ...p,
                                            email: e.target.value
                                        }))
                                    }}
                                />
                                {
                                    !signUpInfo.emailChk &&
                                    <>
                                        {
                                            timeKey === 0 ?
                                                <AuthButton
                                                    loading={loading}
                                                    title='인증번호'
                                                    disabled={emailChk}
                                                    className={`${(!emailChk && signUpInfo.email) ? 'text-primary border-primary' : 'text-[#9D9EB7] border-[#9D9EB7]'} mobile:h-10 !text-base mobile:w-[90px]`}
                                                    onClick={sendEmail}
                                                /> :
                                                <AuthButton
                                                    title='재요청'
                                                    className='hover:bg-transparent border-red mobile:w-[90px] mobile:h-10 text-red hover:!text-red mobile:text-sm'
                                                    onClick={reSendEmail}
                                                />
                                        }
                                    </>
                                }
                            </div>
                            {
                                !signUpInfo.emailChk &&
                                !!serverAuthCode &&
                                <>
                                    <div className='relative mobile:mb-6'>
                                        {
                                            timeKey > 0 &&
                                            <div className='right-6 absolute flex items-center h-full'>
                                                <Timer
                                                    timerKey={timeKey}
                                                    isTimeOut={isTimeOut}
                                                    setIsTimeOut={setIsTimeOut}
                                                />
                                            </div>
                                        }

                                        <CustomInput
                                            type={'text'}
                                            value={authCode}
                                            fontSize='base'
                                            disabled={isTimeOut}
                                            autocompleteOff
                                            maxLength={6}
                                            placeholder={'인증번호를 입력해주세요'}
                                            onChange={(e) => {
                                                setAuthCode(e.target.value)
                                            }}
                                        />
                                    </div>
                                </>
                            }
                        </div>

                        <div className='flex flex-col gap-3'>
                            <div>
                                <p className='font-semibold mobile:text-base text-lg'>
                                    비밀번호<span className='text-red'> *</span>
                                </p>
                                <p className='text-xs'>
                                    비밀번호는 영문 대문자 숫자 특수문자를 포함한 8자리 이상이어야 합니다.
                                </p>
                            </div>
                            <div className='relative w-full'>
                                <CustomInput
                                    type={isShow ? 'text' : 'password'}
                                    value={signUpInfo.password}
                                    autocompleteOff
                                    error={pwChk}
                                    placeholder={'비밀번호를 입력해주세요'}
                                    onBlur={(e) => {
                                        if (e.target.value) {
                                            setPwChk(!correctPw(e.target.value))
                                            if (!correctPw(e.target.value)) {
                                                toast.error('비밀번호 형식이 올바르지 않습니다.')
                                            }
                                        }
                                    }}
                                    onChange={(e) => {
                                        setPwChk(false)
                                        setSignUpInfo({
                                            ...signUpInfo,
                                            password: e.target.value,
                                        })
                                    }}
                                />
                                <div
                                    className='top-0 right-6 absolute flex items-center h-full cursor-pointer'
                                    onClick={() => setIsShow((p) => !p)}
                                >
                                    {isShow ? <EyeOn /> : <EyeOff />}
                                </div>
                            </div>
                        </div>

                        <div className='flex flex-col gap-3'>
                            <p className='font-semibold mobile:text-base text-lg'>
                                상태
                            </p>
                            <CustomSelect
                                height={60}
                                fontSize={18}
                                option={activeSelect}
                                defaultValue={
                                    signUpInfo.isActive !== undefined
                                        ? activeSelect.find(arr => arr.value === (signUpInfo.isActive ? 'Y' : 'N'))
                                        : undefined
                                }
                                placeholder={'사용여부'}
                                onChange={(value) => {
                                    setSignUpInfo(p => ({
                                        ...p,
                                        isActive: value === 'Y' ? true : false
                                    }))
                                }}
                            />
                        </div>
                    </div>

                    <div className='self-end tablet:mt-3 tablet:w-full'>
                        <CustomButton
                            disabled={!clear}
                            className='bg-primary'
                            title='저장하기'
                            onClick={createSubAccount}
                        />
                    </div>
                </div>
            </Container>
        </PageTemplate>
    )
}

export default SubAccountCreate